'use client';

import {useCallback, useEffect, useState} from 'react';
import EventApi from '@/api/event';
import {
  handleLogin,
  loginState,
  handleUserInfo as loginUserInfo,
} from '@/utils/event/util';
import globalDomains from '@/utils/global-domains';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './styles.module.css';
import PersonaList from '@/app/(events)/events/soopi/components/PersonaList';
import {shareLink, navigateToDetail} from '@/app/(events)/events/soopi/utils';

const SoopiEventConversation = ({onBodyId}) => {
  const [loading, setLoading] = useState(false);
  const [userNick, setUserNick] = useState('');
  const [userId, setUserId] = useState('');
  const [personaList, setPersonaList] = useState([]);
  const [ticketData, setTicketData] = useState({
    userTicket: 0,
    rank: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    /**
     * 초기 로드시 body id 셋팅
     */
    onBodyId && onBodyId(styles.body);
    setLoading(true);
  }, [onBodyId]);

  // 로그인 정보 셋팅
  useEffect(() => {
    if (loginState) {
      const {userId, userNickname} = loginUserInfo();
      setUserNick(userNickname);
      setUserId(userId);
    }
  }, [setUserNick, setUserId]);

  const refreshData = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await EventApi.get('/soopi/chance_event.php');
      if (data.result === 1) {
        if (personaList.length === 0) {
          setPersonaList(data.data?.persona || []);
        }
        setTicketData({
          userTicket: data.data?.count?.[0]?.cnt || 0,
          rank: data.data?.top || [],
        });
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, setPersonaList, setTicketData]);

  useEffect(() => {
    AOS.init();

    refreshData();
  }, [refreshData]);

  const onShareLink = () =>
    shareLink(`${globalDomains.WWW_AFREECATV}/events/soopi/conversation`);

  return (
    loading && (
      <>
        <div id='wrap' className={styles.wrap}>
          <header className={styles.header}>
            <div className={styles.inner}>
              <h1>
                <a href={globalDomains.WWW_AFREECATV} target='_blank'>
                  SOOP
                </a>
              </h1>
              <div className={styles.login_wrap}>
                {loginState ? (
                  <>
                    <button
                      type='button'
                      className={styles.account}
                      onClick={handleLogin}>
                      로그아웃
                    </button>
                  </>
                ) : (
                  <button
                    type='button'
                    className={styles.account}
                    onClick={handleLogin}>
                    로그인
                  </button>
                )}
              </div>
            </div>
          </header>
          <div id='conts'>
            {/* Visual Area */}
            <section className={styles.visual_area}>
              <div className={styles.inn}>
                <div className={styles.visual}>
                  <h2 className={styles.item_txt}>
                    <i
                      className={`${styles.ele_1} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='100'>
                      SOOPi와 대화하면
                    </i>
                    <i
                      className={`${styles.ele_2} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='200'>
                      SOOPi와 대화하면
                    </i>
                    <i
                      className={`${styles.ele_3} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='300'>
                      닌텐도 스위치2
                    </i>
                    <i
                      className={`${styles.ele_4} ${styles.ele}`}
                      data-aos='fade-left'
                      data-aos-delay='500'>
                      쏜다!
                    </i>
                  </h2>
                  <div className={styles.item_img}>
                    <i className={styles.ele_gift}></i>
                    <i className={styles.ele_profile}></i>
                    <i className={styles.ele_msg}></i>
                  </div>
                </div>
                <div className={styles.date_wrap}>
                  <p className={styles.period}>11/11(화) - 11/30(일)</p>
                  <span className={styles.winner}>당첨자 발표 12/5(금)</span>
                </div>
                <div className={styles.desc_box}>
                  <strong className={styles.tit}>
                    <p>11월 11일 업데이트로</p>
                    <em>SOOPi는 어떻게 달라졌을까요?</em>
                  </strong>

                  <div className={styles.info_box}>
                    <strong>기억력 향상!</strong>
                    <p>
                      이전 버전의 SOOPi보다
                      <br />더 많은 것을 기억하고 학습할 수 있어요.
                    </p>
                  </div>

                  <div className={styles.info_box}>
                    <strong>이것까지 안다고?</strong>
                    <p>
                      SOOP 플랫폼의 내용만 알던 SOOPi가
                      <br />
                      다양한 분야의 지식까지 학습했어요.
                    </p>
                  </div>

                  <div className={styles.info_box}>
                    <strong>얼굴이 움직인다!</strong>
                    <p>스트리머의 얼굴이 LIVE 2D로 적용되었어요.</p>
                  </div>
                </div>

                <div className={styles.desc_box2}>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_conversation/img/visual_profile.webp`}
                    alt='닌텐도 스위치 2'
                  />{' '}
                  {/* 반복될 프로필 gif */}
                  <p>
                    더 똑똑해진 SOOPi와 재미있는 대화 나누고
                    <br />
                    닌텐도 스위치2까지 받아가세요!
                  </p>
                </div>
              </div>
            </section>
            {/* 이벤트 참여하는 방법 */}
            <section className={styles.event_join}>
              <div className={styles.inn} data-aos='fade-up'>
                <h3>이벤트 참여하는 방법</h3>
                <ol>
                  <li>
                    <em>1</em>
                    SOOPi가 학습한 스트리머를 구독한다.
                  </li>
                  <li>
                    <em>2</em>
                    SOOPi와 재미있게 대화를 나눈다.
                  </li>
                  <li>
                    <em>3</em>
                    대화를 나누며 열심히 응모권을 모으면 경품에 자동 응모!
                  </li>
                </ol>

                <div className={styles.tit_box}>
                  <h4>내가 모은 응모권</h4>
                </div>

                {userId === '' && (
                  <button
                    type='button'
                    onClick={handleLogin}
                    className={styles.login}>
                    <span>로그인이 필요합니다.</span>
                  </button>
                )}

                {userId && (
                  <div className={styles.num}>
                    <span>{ticketData.userTicket}개</span>
                  </div>
                )}

                <div className={styles.ranking_list}>
                  <div className={styles.inner}>
                    <div className={styles.tit_wrap}>
                      <h4>응모권 수집 TOP5</h4>
                      <button
                        type='button'
                        disabled={isLoading}
                        onClick={refreshData}
                        className={styles.ico_refresh}></button>
                    </div>

                    <ol>
                      {ticketData.rank.map((rankItem, idx) => (
                        <li key={rankItem.userId}>
                          <strong className={styles.rank}>{idx + 1}등</strong>
                          <span className={styles.nick}>
                            {rankItem.userNick || rankItem.userId}
                          </span>
                          <div className={styles.num}>
                            <em>{rankItem.cnt}개</em>
                          </div>
                        </li>
                      ))}
                    </ol>

                    <ul className={styles.notice_list}>
                      <li>
                        비정상적인 방법으로 응모권을 수집한 경우, 경품 추첨
                        대상에서 제외됩니다.
                      </li>
                      <li>
                        응모권의 개수는 경품 추첨 확률에 비례합니다.
                        <br />
                        (순위권에 들더라도 경품에 당첨되지 않을 수 있습니다.)
                      </li>
                    </ul>
                  </div>
                </div>

                <i className={styles.ele_gift1}></i>
                <i className={styles.ele_gift2}></i>
                <i className={styles.ele_gift3}></i>
              </div>
            </section>

            {/* SOOPi가 학습한 스트리머 리스트 */}
            <section className={styles.strm_list_wrap}>
              <div className={styles.inn} data-aos='fade-up'>
                <h3>SOOPi가 학습한 스트리머 리스트</h3>
                <PersonaList userId={userId} allPersonaList={personaList} />
              </div>
            </section>
            {/* 경품 영역 */}
            <section className={styles.gift_item_area}>
              <div className={styles.inn} data-aos='fade-up'>
                <h3>이벤트 경품</h3>
                <i className={styles.ele_gift1}></i>
                <div className={styles.info_box}>
                  <div className={styles.desc}>
                    <p>이벤트 기간동안 응모권을 100개 이상 획득한</p>
                    <p>
                      <strong>3명을 추첨</strong>하여 닌텐도 스위치 2 증정
                    </p>
                  </div>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_conversation/img/gift_ntd.png`}
                    alt='닌텐도 스위치 2'
                    className={styles.item_ntd}
                  />
                  <span className={styles.item_tit}>닌텐도 스위치 2</span>
                </div>
                <div className={styles.info_box}>
                  <div className={styles.desc}>
                    <p>이벤트 기간동안 응모권을 획득한</p>
                    <p>
                      <strong>3명을 추첨</strong>하여 SOOP 크레딧 30만원 증정
                    </p>
                  </div>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_conversation/img/gift_cr.png`}
                    alt='SOOP 크레딧'
                    className={styles.item_cr}
                  />
                  <span className={styles.item_tit}>SOOP 크레딧 30만원</span>
                </div>
                <div className={styles.info_box}>
                  <div className={styles.desc}>
                    <p>이벤트 기간동안 SOOPi 스트리머를 구독한</p>
                    <p>
                      <strong>100명을 추첨</strong>하여 문화상품권 1만원 권 증정
                    </p>
                  </div>
                  <img
                    src={`${globalDomains.RES_AFREECATV}/eventzone/event/2025/soopi_conversation/img/gift_card.png`}
                    alt='문화상품권'
                    className={styles.item_card}
                  />
                  <span className={styles.item_tit}>문화상품권 1만원</span>
                </div>
                <i className={styles.ele_gift2}></i>
              </div>
            </section>

            {/* 일정 영역 */}
            <section className={styles.schedule_area}>
              <div className={styles.inn}>
                <h3>이벤트 일정</h3>
                <div className={styles.event_detail}>
                  <dl>
                    <dt>이벤트 기간</dt>
                    <dd>2025.11.11(화) ~ 2025.11.30(일)</dd>
                  </dl>
                  <dl>
                    <dt>당첨자 발표</dt>
                    <dd>2025.12.5(금)</dd>
                  </dl>
                </div>
                <button
                  onClick={navigateToDetail}
                  type='button'
                  className={styles.detail}>
                  SOOPi 자세히 알아보기
                </button>
                <button
                  onClick={onShareLink}
                  type='button'
                  className={styles.share}>
                  이벤트 링크 공유하기
                </button>
              </div>
            </section>
            {/* 주의사항 영역 */}
            <section className={styles.notice_area}>
              <div className={styles.inn}>
                <h3>유의사항</h3>
                <ul>
                  {[
                    '이벤트 당첨자 발표는 12월 5일(금) SOOPi 방송국에서 안내해 드립니다.',
                    '이벤트 당첨자는 쪽지로 개별 안내 예정이오니 사전에 쪽지 수신 거부를 해제해주세요.',
                    'SOOPi 서비스를 직접 구독하여 이용한 유저에게만 상품 지급됩니다.',
                    '당첨자 본인 명의 계정에만 경품이 지급됩니다.',
                    '경품 지급 과정에 필요한 정보를 요청할 예정입니다. 요구되는 정보를 전달주셔야 경품 지급이 가능합니다.',
                    '5만원을 초과하는 경품 당첨시, 소비자의 제세공과금 22% 납부가 필요 합니다.',
                    '경품의 색상은 선택이 불가능하며 수급 사정에 따라 동일 가격대의 유사 한 제품으로 대체되어 발송 될 수 있습니다.',
                    '비정상적이거나 불법적인 방법으로 이벤트에 참여하신 경우 경품 지급 대상에서 제외 되며, 법적인 처벌을 받을 수 있습니다.',
                    '본 이벤트는 사정에 의하여 사전 고지 없이 내용 변경 또는 조기 종료될 수 있습니다.',
                  ].map((notice) => (
                    <li key={notice}>{notice}</li>
                  ))}
                </ul>
              </div>
            </section>
          </div>
          <footer className={styles.footer}>© SOOP Corp.</footer>
        </div>
      </>
    )
  );
};

export default SoopiEventConversation;
